import {getContext, hasContext, setContext} from 'svelte';
import type {CssSize} from 'shared/ui-widgets/types';

const masonryGridContextKey = 'masonry-grid-ctx';

interface MasonryGridContext {
    updateGrid: () => void;
    rowGap: CssSize;
}

export function createMasonryGridContext(updateGrid: () => void, rowGap: CssSize) {
    setContext<MasonryGridContext>(masonryGridContextKey, {
        updateGrid,
        rowGap
    });
}

export function getMasonryGridContext() {
    if (!hasContext(masonryGridContextKey)) {
        throw new Error('Masonry context does not exist! You can use KpMasonryGridItem only in KpMasonryGrid.');
    }

    return getContext<MasonryGridContext>(masonryGridContextKey);
}